import React from "react"
import Row from './row'
import AddBat from "./AddBat"
import {Box} from "@mui/material"

export default function BatchManagement(){
    return(
        <>
        {/* <AddBat /> */}
        <Box>
            <Row />
        </Box>
        </>
    )
}